import type { StaffCoordinationSuggestionResponse } from '@/types/apps/staff-coordination-suggestion.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export interface StaffCoordinationSuggestionServiceInterface {}

type StaffCoordinationSuggestionListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationSuggestionResponse>
>;

export class StaffCoordinationSuggestionService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/staff-coordination/suggestion',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationSuggestionListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }
}
